import { createFileRoute } from "@tanstack/react-router";

import { AutoScale } from "../components/site/AutoScale";
import { Footer } from "../components/site/Footer";
import { Header } from "../components/site/Header";
import { ScrollToTop } from "../components/site/ScrollToTop";
import { SpecialOffer } from "../components/home/SpecialOffer";
import { AboutHero } from "../components/about/AboutHero";
import { ResultFocus } from "../components/about/ResultFocus";
import { Specialists } from "../components/about/Specialists";
import { TeamGrid } from "../components/about/TeamGrid";
import { Ratings } from "../components/about/Ratings";
import { Career } from "../components/about/Career";
import { Office } from "../components/about/Office";
import { breadcrumbJsonLd, buildMeta, SITE_URL } from "../lib/site";
import { crumbTuples } from "../lib/breadcrumbs";

const title = "О маркетинговом агентстве HAY — команда и экспертиза";
const description =
  "Команда HAY.agency: разработка сайтов и веб-сервисов, SEO, реклама, CRM, аналитика и автоматизация. Используем ИИ как рабочий инструмент команды.";


export const Route = createFileRoute("/about")({
  head: () => ({
    ...buildMeta({
      title,
      description,
      path: "/about",
      image: `${SITE_URL}/og/default.webp`,
      imageWidth: 1200,
      imageHeight: 630,
      imageAlt: "О маркетинговом агентстве HAY",
      locale: "ru_RU",
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "AboutPage",
              "@id": `${SITE_URL}/about#page`,
              url: `${SITE_URL}/about`,
              name: title,
              description,
              about: { "@id": `${SITE_URL}/#organization` },
              isPartOf: { "@id": `${SITE_URL}/#website` },
            },
            breadcrumbJsonLd(crumbTuples("/about"), { inGraph: true }),
          ],
        }),
      },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <AutoScale>
      <div className="min-h-screen bg-background font-sans text-foreground antialiased">
        <SpecialOffer />
        <Header />
        <main>
          <AboutHero />
          <ResultFocus />
          <Specialists />
          <TeamGrid />
          <Ratings />
          <Career />
          <Office />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </AutoScale>
  );
}
